/**
 * The Voice Mode level display (`VoiceModeWaveform`) reads a microphone stream.
 * A null stream means the session is not recording; the display then follows
 * the thinking chirps while they run. This component never controls the
 * microphone.
 */
import { observer } from 'mobx-react-lite';
import { motion, useReducedMotion } from 'motion/react';

import { getThinkingChirpsStream } from '@/features/sounds/sounds';
import { EASE } from '@/lib/animate';

import { BIRDSONG_BAR_LAYOUT } from './audio-visualizer-bars';
import { AudioVisualizer } from './MicrophoneButton';

interface VoiceModeWaveformProps {
  mediaStream: MediaStream | null;
  disableLayoutAnimation?: boolean;
}

export const VoiceModeWaveform = observer(function VoiceModeWaveform({
  mediaStream,
  disableLayoutAnimation = false,
}: VoiceModeWaveformProps) {
  const shouldReduceMotion = useReducedMotion();
  const chirpsStream = getThinkingChirpsStream();

  return (
    <motion.div
      layout={!disableLayoutAnimation && !shouldReduceMotion}
      className="flex items-center justify-end overflow-hidden cursor-default"
      transition={{ type: 'tween', duration: 0.18, ease: EASE.outQuint }}
    >
      <AudioVisualizer
        mediaStream={mediaStream ?? chirpsStream}
        barLayout={mediaStream ? undefined : BIRDSONG_BAR_LAYOUT}
      />
    </motion.div>
  );
});
